import { ROOT_NODE, useEditor, useNode } from "@craftjs/core";
import React, { useContext, useLayoutEffect, useMemo } from "react";
import icon from "./icon";
import { GrigoraEditorContext } from "../../editor/context";
import { GrigoraDashboardContext } from "../../dashboard/context";
import blockActions from "../../block-actions";

export const Page = ({ children, ...props }) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
    dom,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
    dom: state.dom,
  }));

  const {
    actions,
    query,
    query: { node },
  } = useEditor();
  const childrens = node(id).childNodes();

  const {
    editorDocument = document,
    screen,
    editorWindow = window,
  } = useContext(GrigoraDashboardContext) ?? {};

  var editorContext = useContext(GrigoraEditorContext);

  const isPostEditor = screen !== "site-editor";

  // Empty String
  var cnt =
    "This is an empty page. Please click here or drag and drop elements to start.";
  if (
    editorContext &&
    editorContext.currentPage &&
    editorContext.currentPage.startsWith &&
    editorContext.currentPage.startsWith("component-")
  ) {
    cnt = "This is an empty component. Please add one container.";
  }

  const addNewBlockInEnd = () => {
    blockActions.insertInside(
      actions,
      query,
      ROOT_NODE,
      "grigora/text",
      false,
      editorDocument,
    );
  };

  return (
    <div
      {...props}
      ref={(ref) => connect(drag(ref))}
      style={{
        width: "100%",
        height: isPostEditor ? "100%" : undefined,
        maxWidth: "100%",
        padding: isPostEditor ? "20px" : undefined,
        paddingBottom: isPostEditor ? "250px" : undefined,
      }}
      className={`g-page`}
      data-grigora-block="true"
      data-grigora-block-id={id}
      onClick={(e) => {
        if (isPostEditor && dom) {
          // Check if is clicked in bottom 250px of the this element
          // This element is scrollable, so we'll have to add scroll height
          // to the e.clientY
          var box = dom.getBoundingClientRect();
          if (box) {
            if (e.clientY > box.bottom - 250) {
              // Add a new block if empty block is not present. Otherwise, focus on the empty block

              // Get last child from dom
              var lastChild = dom.lastChild;

              if (
                lastChild &&
                // Is [data-grigora-block-type] present?
                lastChild.getAttribute &&
                lastChild.getAttribute("data-grigora-block-type") &&
                // Is [data-grigora-block-type] is grigora/text?
                lastChild.getAttribute("data-grigora-block-type") ===
                  "grigora/text" &&
                // If is text block empty with [data-is-empty]===true?
                lastChild.getAttribute("data-is-empty") === "true"
              ) {
                // Focus on rich text input of the last child
                var richTextInput = lastChild.querySelector(
                  ".grigora-richtext-input__field",
                );
                if (richTextInput) {
                  richTextInput.focus();
                }
              } else {
                addNewBlockInEnd();
              }
            }
          }
        }
      }}
    >
      {Array.isArray(childrens) && childrens.length === 0 ? (
        <>
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              addNewBlockInEnd();
            }}
            className="empty-page"
            contentEditable={false}
            style={{
              userSelect: "none",
            }}
          >
            {cnt}
          </div>
        </>
      ) : null}
      {children}
    </div>
  );
};

export const PageSettings = () => {
  const {
    background,
    padding,
    actions: { setProp },
  } = useNode((node) => ({
    background: node.data.props.background,
    padding: node.data.props.padding,
  }));

  return (
    <div className="text-gray-600 text-grigora-base px-3 text-center w-full h-full flex items-center justify-center mt-[50px]">
      This is the canvas page block. No settings are available.
    </div>
  );
};

export const PageDefaultProps = {};

// To Avoid Mangling in Production
Page.displayName = "Page";

Page.craft = {
  name: "Page",
  props: PageDefaultProps,
  related: {
    settings: PageSettings,
    icon: icon,
    hideFromToolbox: true,
  },
  custom: {
    name: "Page",
    slug: "grigora/page",
  },
};
